import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const userModURL = "api/v1/auth/users";
//obtaining the paginated data
export const getUser = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${userModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all data
export const getAllUser = () => axiosInstance.get(`${userModURL}/list?ordering=-id`);

export const getCurrentUser = (decoded) => axiosInstance.get(`${userModURL}/${decoded.user_id}`);
//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageUser = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${userModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createUser = (body) =>
  axiosInstance.post(`${userModURL}/create`, body, {
    "Content-Type": "multipart/form-data",
  });

//deleting function
export const deleteUser = (id) => axiosInstance.delete(`${userModURL}/${id}`);

//update function
export const updateUser = (id, body) =>
  axiosInstance.patch(`${userModURL}/${id}`, body, {
    "Content-Type": "multipart/form-data",
  });

// get specific user
export const getSpecificUser = (id) => axiosInstance.get(`${userModURL}/retrieve/${id}`);
//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${userModURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantData = (e, cancelToken) =>
  axiosInstance.get(`${userModURL}/list?user_name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
//deleting the image
export const deletePhoto = (id, body) => axiosInstance.patch(`${userModURL}/${id}`, body);
//change password
export const changePassword = (id, body) => axiosInstance.get(`api/v1/user-app/change-password/${id}`, body);
